import { PersonSearch } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";

import { ButtonProps } from "@/types/button";

import { useRecaptcha } from "@/context/util/recaptcha";

export default function ForgotButton(props: ButtonProps) {
  const { showV2 } = useRecaptcha();

  function getTooltip() {
    if (showV2) {
      return `Please complete the reCAPTCHA ${props.tooltipSuffix}`;
    }
    return `Click ${props.tooltipSuffix}`;
  }

  return (
    <Tooltip title={getTooltip()}>
      <Button
        disabled={showV2}
        onClick={() => props.onClick()}
        sx={{
          height: 48,
          marginTop: 2,
          width: { xs: "100%" },
        }}
        startIcon={props.startIcon ?? <PersonSearch />}
        variant="text"
      >
        {props.label ?? "Reset"}
      </Button>
    </Tooltip>
  );
}
